/* eslint-disable @typescript-eslint/no-explicit-any */
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { generateClient } from 'aws-amplify/api';

import { getProperty } from './get-property';

type AuthMode = 'apiKey' | 'iam' | 'identityPool' | 'lambda' | 'none' | 'oidc' | 'userPool';

const client = generateClient();

export const getError = (payload: any) => {
  const errors = getProperty(payload, 'errors');
  const error = new GqlError('Unknown Error', errors);

  if (Array.isArray(errors)) {
    const message =
      errors
        .map((e) => e.message)
        .filter((e) => !!e)
        .join('\n') || 'Unknown Error';
    error.message = message;
  }
  return error;
};

export const getErrorFromResult = (result: any) => {
  if (result && result.data) {
    const values = Object.values(result.data);

    if (values[0] && typeof values[0] === 'string') {
      try {
        const jsonResponse = JSON.parse(values[0]);

        if (
          typeof jsonResponse === 'object' &&
          'success' in jsonResponse &&
          'message' in jsonResponse &&
          !jsonResponse.success
        ) {
          return { errors: [{ message: jsonResponse.message }] };
        }
      } catch (ex) {
        console.log(ex);
      }
    }
  }
};

export const executeGql = async <T = Record<string, unknown>>(
  query: string,
  variables?: Record<string, unknown>,
  authMode: AuthMode = 'userPool',
): Promise<GraphQLResult<T>> => {
  try {
    const result = await client.graphql({
      query,
      variables,
      authMode,
    });

    const errorFromResponse = getErrorFromResult(result);

    if (errorFromResponse) {
      throw errorFromResponse;
    }

    return result as GraphQLResult<T>;
  } catch (ex) {
    console.log({ ex });
    const raisedError = getError(ex);
    console.error(raisedError);
    throw raisedError;
  }
};

export const processGqlResult = <T>(key: string, payload: any) => {
  const json = getProperty(payload, `data.${key}`);
  return json as T;
};

export class GqlError extends Error {
  private _payload: any;

  constructor(message: string, payload: any) {
    super(message);
    Object.setPrototypeOf(this, GqlError.prototype);
    this._payload = payload;
  }

  get payload() {
    return this._payload;
  }
}
